const timeZones = Intl.supportedValuesOf('timeZone').filter(
    (tz) => tz.startsWith('America/') || tz.startsWith('Pacific/')
);

export default timeZones;

// The browser may list a stored zone only under an alias (America/Godthab for America/Nuuk).
export function timeZoneOptions(current) {
    return !current || timeZones.includes(current) ? timeZones : [...timeZones, current].sort();
}
